import React, { useEffect, useState } from 'react'
import PageHeader from '../../../components/pageHeader/PageHeader';
import PageButtons from '../../../components/pageComponents/PageButtons';
import PageWrapper from '../../../components/pageComponents/PageWrapper';
import SearchContainer from '../../../components/pageComponents/SearchContainer';
import useDidMountEffect from '../../../hooks/useDidMountEffect/useDidMountEffect';
import { useManagePostRequest } from '../../../hooks/useManagePostRequest/useManagePostRequest';
import styled from "styled-components";
import ModalEnabled from "../../../components/modalComponents/ModalEnabled";
import CrearDocumento from "./modales/CrearDocumento/CrearDocumento";
import TableAdminListarDocumentos from "./TableAdminListarDocumentos";
import {
    getAllAreasAPI,
    getAllDocumentoTipoDistribucionAPI,
    getIndexFlujoDocumentosAPI
} from "../../../consumers/backendApisUrls";
import {useGetRequest} from "../../../hooks/useGetRequest/useGetRequest";
import {initialAllOptionPromises, jsonNoEstaVacio, updateFiltersWithExtraData} from "../../../helper/utils";

const INIT_KEYS = {
    IdsTipoDistribucion: "IdsTipoDistribucion",
    IdsAreas: "IdsAreas",
};

const AdminListarFlujoDocumentos = () => {

    const [formValues, setFormValues] = useState({Items: [], ExtraData: {}});
    const [searchCriteria, setSearchCriteria] = useState("");
    const [paginator, setPaginator] = useState({CurrentPage: 1});
    const [isLoading, setIsLoading] = useState(true);
    const [allFilters, setAllFilters] = useState([]);
    const [executeManagePost] = useManagePostRequest();
    const [executeGet] = useGetRequest();

    const [modalEnabled, setModalEnabled] = useState({
        isEnable: false,
        component: React.Fragment,
    });

    const initialPromises = () => {
        return [
            executeGet(getAllDocumentoTipoDistribucionAPI()),
            executeGet(getAllAreasAPI()),
        ];
    }

    const init = async () => {
        setIsLoading(true);
        try {
            await initialAllOptionPromises(initialPromises, Object.values(INIT_KEYS), setAllFilters);

            await manageSearch();
            if (formValues.filters.length === 0) {
                jsonNoEstaVacio(formValues.ExtraData) &&
                updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    const handleUpdatedFilters = (res) => {
        setFormValues(lastData => ({...lastData, filters: res}))
    }

    const manageSearch = async () => {
        setIsLoading(true);
        const payload = getPayload();
        await executeManagePost(getIndexFlujoDocumentosAPI(), payload, successManageSearchCallback);
        setIsLoading(false);
    }

    const getPayload = () => {
        return {
            Criteria: searchCriteria,
            Page: paginator.CurrentPage,
            ...formValues.selectedFilters
        }
    }


    const successManageSearchCallback = ({data}) => {
        const {Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage} = data;
        setFormValues(lastData => ({...lastData, Items, ExtraData}));
        setPaginator({TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage});
        setIsLoading(false);
    }

    const handleCleanSearch = () => {
        setFormValues({...formValues, selectedFilters: null});
    }

    useDidMountEffect(() => {
        manageSearch();
    }, [paginator.CurrentPage, formValues.selectedFilters])

    useDidMountEffect(() => {
        jsonNoEstaVacio(formValues.ExtraData) && updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
    }, [formValues.ExtraData])

    useEffect(() => {
        init();
    }, [])

    return (
        <PageWrapper isLoading={isLoading}>
            <ModalEnabled
                modalEnabled={modalEnabled}
                setModalEnabled={setModalEnabled}
                refreshPage={manageSearch}
            />
            <PageHeader title="Lista de Documentos" />
            <SearchContainer
                searchCriteria={searchCriteria}
                setSearchCriteria={setSearchCriteria}
                setPaginator={setPaginator}
                manageSearch={manageSearch}
                addCleanSearch={handleCleanSearch}>
                <ButtonsWrapper>
                    <PageButtons
                        hasBackButton
                        hasCreateButton={formValues?.ExtraData?.PuedeCrear === true}
                        handleCreateButton={() =>
                            setModalEnabled({
                                isEnable: true,
                                component: CrearDocumento,
                                data: { disableInputs: false, isCreate: true }
                            })
                        }
                    />
                </ButtonsWrapper>
            </SearchContainer>
            <TableAdminListarDocumentos
                formValues={formValues}
                setFormValues={setFormValues}
                extraData={formValues.ExtraData}
                setModalEnabled={setModalEnabled}
                paginator={paginator}
                setPaginator={setPaginator}
                keys={INIT_KEYS}
                isAdmin={true}
                manageSearch={manageSearch}
            />



        </PageWrapper>
    );
}

export default AdminListarFlujoDocumentos;


const ButtonsWrapper = styled.div`
    display: block;
    @media (max-width: 796px) {
        display: none;
    }
`;